module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f3e8aa205c0cf65ba99922ce1f3fc94e.gif";